import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const COOKIE_KEY = "tb_cookie_consent_v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const v = localStorage.getItem(COOKIE_KEY);
    if (!v) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem(COOKIE_KEY, JSON.stringify({ accepted: true, at: new Date().toISOString() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 z-50 max-w-md" data-testid="cookie-banner">
      <div className="bg-black text-white rounded-2xl border border-[#3B82F6] p-5 shadow-2xl">
        <div className="flex items-start gap-3">
          <Cookie className="w-6 h-6 text-[#3B82F6] flex-shrink-0 mt-1"/>
          <div className="flex-1">
            <div className="font-display text-lg mb-1">Cookie tecnici</div>
            <p className="text-xs text-white/80 leading-relaxed">
              Usiamo solo cookie tecnici essenziali (sessione, preferenze). Nessuna profilazione, nessun tracker pubblicitario.
              Più info nella <Link to="/privacy" className="text-[#3B82F6] underline">Privacy Policy</Link>.
            </p>
            <button
              onClick={accept}
              data-testid="cookie-accept"
              className="mt-3 bg-[#3B82F6] hover:bg-white hover:text-black text-white text-sm font-semibold px-5 py-1.5 rounded-full transition-colors"
            >
              Ho capito
            </button>
          </div>
          <button onClick={accept} className="text-white/60 hover:text-white">
            <X className="w-4 h-4"/>
          </button>
        </div>
      </div>
    </div>
  );
}
